module.exports = __webpack_public_path__ + "img/banner-hen-jp.bcede13b.png";